import { useTranslation } from 'react-i18next'

function useT() {
  const { t: tDefault } = useTranslation()

  function t(value: any) {
    switch (typeof value) {
      case 'string':
        try {
          const { message, params } = JSON.parse(value)
          return tDefault(message, params)
        } catch (error) {}
        return value ? tDefault(value) : ''

      case 'object':
        if (value.hasOwnProperty('$$typeof')) {
          return value
        }
        try {
          const { message, params } = value
          return tDefault(message, params)
        } catch (error) {}
        return value

      default:
        return value
    }
  }

  return { t }
}

function stringify(tmessage: string, params: object) {
  return JSON.stringify({ message: tmessage, params })
}

interface Props {
  title: string
  options?: Object
}

function T({ title, options = null }: Props): JSX.Element {
  const { t } = useTranslation()
  return t(title, options)
}

export { stringify, useT, T }
